<ng-template let-modal #chatBot>
    <div class="chatbot-container">
        <div class="chatbot-header">
            <h2 class="title">{{ title }}</h2>
            <button class="rounded-circle chatbot-refresh" (click)="newConversation()">
                <fa-icon [icon]="['fal', 'refresh']" size="lg"></fa-icon>
            </button>
            <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
        </div>
        <div #chatbotBody class="chatbot-body">
            <app-chatbot-message
                *ngFor="let message of this.chatService.messages"
                [message]="message">
            </app-chatbot-message>
            @if (this.chatService.messages.length === 1){
                <app-example-questions (exampleQuestionClicked)="this.sendExampleMessage($event)">
                </app-example-questions>
            }
            @if (this.displayLoadingAnim){
                <app-loading-animation></app-loading-animation>
            }
        </div>
        <form class="chatbot-footer" (ngSubmit)="sendMessage()">
            <input type="text" id="chatBotInput" name="chatBotInput" autocomplete="off"
                   [(ngModel)]="textInput" class="form-control" placeholder="Nachricht eingeben">
            <button class="rounded-circle chatbot-send" type="submit">
                <fa-icon [icon]="['fal', 'paper-plane']" size="lg"></fa-icon>
            </button>
        </form>
    </div>
</ng-template>
